export const plans = state => {
    return state.plans;
};


// WEBPACK FOOTER //
// ./src/store/modules/subscription/getters.js